























import { Vue, Component } from 'vue-property-decorator';
import NewsList from './components/NewsList.vue';
import * as config from './config';
import { getVoteList } from '@/api/api.ts';
import DetailModal from './components/DetailModal.vue';
import { Popup } from 'vant';
type Target = 'detail' | 'success';
@Component({
  components: {
    DetailModal,
  },
})
export default class Second extends Vue {
  option = config.OPTHINES;
  ListData = [];
  active = 0;
  Detail = {};
  modalVisible = false;
  target: Target = 'success';
  async created() {
    const res = await getVoteList({
      voteName: this.option.voteName,
    });
    this.ListData = res.data;
  }
  showContent(item: any) {
    this.Detail = item;
    console.log(item);
    this.modalVisible = true;
  }
  toggleModal() {
    this.modalVisible = false;
  }
}
